module.exports = __webpack_public_path__ + "img/invoice.b7699568.svg";